import React from 'react';

const BackgroundAnimation = () => {
  return <div className="background-animation"></div>;
};

export default BackgroundAnimation;
